import { CircularProgress, Grid, makeStyles } from '@material-ui/core';
import React from 'react';

const AppLoadingContainer: React.FC = () => {
  const classes = useStyles();

  return (
    <Grid className={classes.container} container justify="center" alignItems="center">
      <Grid item>
        <CircularProgress variant="indeterminate" disableShrink />
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    height: '100vh',
  },
}));

export default AppLoadingContainer;
